//GLOBAL CONSTANTS FOR STANDARD HEIGHT AND WIDTHS
export const STANDARD_HEADER_HEIGHT = 64;
export const STANDARD_TAB_HEIGHT = 48;
export const STANDARD_FOOTER_HEIGHT = 71;
export const BOTTOM_NAV_HEIGHT = 68;
export const SECONDARY_ACTION_CONTAINER_HEIGHT = STANDARD_HEADER_HEIGHT - 25;
export const STANDARD_INPUT_HEIGHT = 40;

/** Overlap (px) so the record editable container sits under the header gradient and top radius is visible */
export const RECORD_EDITABLE_HEADER_OVERLAP = 20;

/** Overlap (px) so the home content rounded top sits under the header and corners are visible */
export const HOME_HEADER_OVERLAP = 40;

/** Offset (px) subtracted from HOME_HEADER_OVERLAP for content marginTop so rounded top is visible */
export const HOME_HEADER_OVERLAP_OFFSET = 12;

//SHARED ICON SIZING CONSTANTS
export const ICON_LARGE_SIZE = 64;
export const ICON_SMALL_SIZE = 20;
export const ICON_EXTRA_SMALL_SIZE = 16;

//SAFE AREA HELPERS FOR MOBILE DEVICES (NOTCH, HOME INDICATOR, STATUS BAR)
// These helpers return CSS env() values that automatically adapt to device safe areas
// On devices without safe areas (desktop, older phones), they return 0px
export const getSafeAreaBottom = () => 'env(safe-area-inset-bottom, 0px)';
export const getSafeAreaTop = () => 'env(safe-area-inset-top, 0px)';
export const getSafeAreaLeft = () => 'env(safe-area-inset-left, 0px)';
export const getSafeAreaRight = () => 'env(safe-area-inset-right, 0px)';

// Helpers to combine fixed height with safe area
// Use these when positioning elements relative to screen edges
export const getBottomWithSafeArea = (baseHeight: number) =>
  `calc(${baseHeight}px + ${getSafeAreaBottom()})`;

export const getTopWithSafeArea = (baseHeight: number) =>
  `calc(${baseHeight}px + ${getSafeAreaTop()})`;

// NON-MATCHED MAP POINT STYLING
// Applied to map points that fall outside the active filters when they are
// shown as background context. Deliberately independent of any Display By
// colouring so filtered results stay distinguishable at a glance.
export const NON_MATCHED_POINT_DIAMETER = 13;
export const NON_MATCHED_POINT_RADIUS = NON_MATCHED_POINT_DIAMETER / 2;
export const NON_MATCHED_POINT_FILL = '#949494';
export const NON_MATCHED_POINT_STROKE = 'rgba(255, 255, 255, 0.85)';
export const NON_MATCHED_POINT_STROKE_WIDTH = 1.5;
